import { useDispatch } from 'react-redux';

import { OrderType } from 'api/TrackingApi';
import {
  setOneClickPaymentStatus,
  setOneClickPaymentVerifyUrl,
} from 'store/oneClickPayment/oneClickPaymentSlice';

import { usePayment3dsPopupTracking } from './usePayment3dsPopupTracking';

interface ITrackingProps {
  enabled: boolean;
  orderType: OrderType;
  orderId: string;
}

interface IProps {
  tracking?: ITrackingProps;
  url: string;
  onMount?: () => void;
  onSubmit?: () => void;
  onClose?: () => void;
}

export const usePayment3dsPopup = ({
  tracking,
  url,
  onMount,
  onSubmit,
  onClose,
}: IProps) => {
  const dispatch = useDispatch();

  const { track3dsPopupMount, track3dsPopupSubmit, track3dsPopupClose } =
    usePayment3dsPopupTracking({
      orderType: tracking?.orderType,
      orderId: tracking?.orderId,
    });

  const handle3dsPopupMount = () => {
    tracking?.enabled && track3dsPopupMount();

    onMount && onMount();
  };

  const handle3dsPopupSubmit = () => {
    tracking?.enabled && track3dsPopupSubmit();

    if (onSubmit) {
      onSubmit();
    } else {
      window.open(url, '_blank');

      dispatch(setOneClickPaymentVerifyUrl(null));
    }
  };

  const handle3dsPopupClose = () => {
    tracking?.enabled && track3dsPopupClose();

    if (onClose) {
      onClose();
    } else {
      dispatch(setOneClickPaymentStatus(null));
      dispatch(setOneClickPaymentVerifyUrl(null));
    }
  };

  return {
    handle3dsPopupMount,
    handle3dsPopupSubmit,
    handle3dsPopupClose,
  };
};
